/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import useWithdrawalFields from './useWithdrawalFields'
import Field from '@consteed/overrides/components/field'

const WithdrawalFields = ({form, prefix = ''}) => {
    const fields = useWithdrawalFields({form, prefix})
    return (
        <Stack spacing={5}>
            <Field {...fields.name} />
            <Field {...fields.email} />
            <Field {...fields.orderNumber} />
        </Stack>
    )
}

WithdrawalFields.propTypes = {
    form: PropTypes.object.isRequired,
    prefix: PropTypes.string
}

export default WithdrawalFields
